import React from "react";

const Sidebar = ({
  // isOpen = false,
  // onClose = () => {},
  children,
  width = "300px",
  height = "100vh",
  offsetTop = 0,
  position = "right",
  backgroundColor = "#fff",
  color = "#000",
  padding = "1rem",
  // transition = "0.3s",
  zIndex = 1000,
  // boxShadow = "0 2px 10px rgba(0,0,0,0.1)",
  boxShadow="0 0 12px rgba(0,0,0,0.15)",
  border = "none",
  borderRadius = "0",
  fontFamily = "inherit",
  fontSize = "1rem",
  // showOverlay = true,
  // CloseButton, 
}) => {
  const positions = {
    left: { top: offsetTop, left: 0, height, width },
    right: { top: offsetTop, right: "15px", height, width },
    top: { top: offsetTop, left: 0, width: "100%", height },
    bottom: { bottom: "15px", left: 0, width: "100%", height },
  };

  const style = {
    position: "fixed",
    backgroundColor,
    color,
    padding,
    // transition: `transform ${transition} ease`,
    zIndex,
    boxShadow,
    border,
    borderRadius,
    fontFamily,
    fontSize,
    height: height === "100vh" ? `calc(100vh - ${offsetTop}px)` : height,
    maxHeight: height === "100vh" ? `calc(100vh - ${offsetTop}px)` : height,
    overflowY: "auto",
    overflowX: "hidden",
    ...positions[position],
    // transform: isOpen
    //   ? "translate(0,0)"
    //   : position === "left"
    //   ? "translateX(-100%)"
    //   : position === "right"
    //   ? "translateX(100%)"
    //   : position === "top"
    //   ? "translateY(-100%)"
    //   : "translateY(100%)",
  };

  return (
    <>
      {/* {showOverlay && (
        <div
          style={{
            display: isOpen ? "block" : "none",
            position: "fixed",
            top: offsetTop,
            left: 0,
            width: "100%",
            height: `calc(100% - ${offsetTop}px)`,
            zIndex: zIndex - 1,
            background: "rgba(0, 0, 0, 0.3)",
            transition: `opacity ${transition} ease`,
          }}
          onClick={onClose}
        />
      )}
      <div style={style}>
        {CloseButton ? (
          <div onClick={onClose}>{CloseButton}</div>
        ) : (
          <button
            onClick={onClose}
            style={{
              border: "none",
              background: "transparent",
              fontSize: "1.5rem",
              cursor: "pointer",
              float: "right",
            }}
          >
            ✕
          </button>
        )}

        <div>{children}</div>
      </div> */}
       <div style={style}>{children}</div>
    </>
  );
};

export default Sidebar;
